import { render } from "./OrderPartAddProduct.vue?vue&type=template&id=08c71435&scoped=true"
import script from "./OrderPartAddProduct.vue?vue&type=script&lang=js"
export * from "./OrderPartAddProduct.vue?vue&type=script&lang=js"

import "./OrderPartAddProduct.vue?vue&type=style&index=0&id=08c71435&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c71435"]])

export default __exports__